<template>
  <div class="pitches-wrapper">
    <!-- company-profile display -->
    <div
      class="company-profile-container"
      v-show="pitches_list == true"
      v-animate-css="'fadeIn'"
    >
      <div class="company-profile-body">
        <div class="pitches-item-header" v-if="user.pitches.length > 0">
          <label class="title"
            >All Pitches({{ user.pitches.length | validate }})</label
          >
          <div class="options">
            <button class="add-btn" @click="addUpdateForm()">
              Add Pitch +
            </button>
          </div>
        </div>

        <div class="search-add-btn-widget" v-if="user.pitches.length > 0">
          <div class="search-widget">
            <img src="@/assets/icons/search.svg" alt />
            <input
              v-model="search_pitch_input"
              @keyup="searchPitch"
              type="text"
              name
              id
              placeholder="Type in to Search…"
            />
          </div>
        </div>
        <ul class="pitches-items" v-if="user.pitches.length > 0">
          <li class="pitches-starter"></li>
          <li
            class="pitches-item"
            v-for="(item, index) in user.pitches"
            :key="index"
          >
            <panel-expand :expand="index === 0">
              <template v-slot:header="{ options }">
                <div class="pitches-item-header">
                  <div class="pitches-item-brand">
                    <img
                      v-if="user.company_info.company_logo"
                      :src="
                        $fullUrl(
                          'images/profiles/' + user.company_info.company_logo
                        )
                      "
                    />
                    <img v-else src="@/assets/icons/logo_avatar.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.title | validate }}</label>
                      <span>{{ item.assignment_name | validate }}</span>
                      <span class="date">{{
                        item.created_at | formatDate | validate
                      }}</span>
                    </div>
                    <div class="options">
                      <!-- Dropdown -->
                      <dropdown-menu>
                        <ul>
                          <li>
                            <a href @click.prevent="SendPitch(item)"
                              >Send Pitch</a
                            >
                          </li>
                          <li>
                            <a href @click.prevent="getSinglePitch(item, index)"
                              >Edit Pitch</a
                            >
                          </li>
                          <li>
                            <a href @click.prevent="removePitch(item, index)"
                              >Remove Pitch</a
                            >
                          </li>
                        </ul>
                      </dropdown-menu>
                      <!-- End of dropdown -->

                      <button
                        class="toogle-panel-btn"
                        @click="options.expanded = !options.expanded"
                        v-if="!options.expanded"
                      >
                        <img src="@/assets/admin-icon/icon-down.svg" />
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:main="{ options }">
                <div class="pitches-item-body">
                  <div class="pitches-info">
                    <h5>Description</h5>
                    <p>{{ item.description | validate }}</p>
                  </div>

                  <ul class="consultants-items">
                    <li class="consultants-starter">
                      <div class="consultants-item-header">
                        <label
                          >All Consultants ({{
                            item.consultants.length | validate
                          }})</label
                        >
                        <!-- <button class="export-cv-btn">Export CV</button> -->
                      </div>
                    </li>

                    <li
                      class="consultants-item"
                      v-for="(val, j) in item.consultants"
                      :key="j"
                    >
                      <panel-expand>
                        <template v-slot:header="{ options }">
                          <div class="consultants-item-header">
                            <div class="consultants-item-brand">
                              <img
                                v-if="val.profile_picture"
                                :src="
                                  $fullUrl(
                                    'images/profiles/' + val.profile_picture
                                  )
                                "
                                alt
                              />
                              <img
                                v-else
                                src="@/assets/icons/logo_avatar.svg"
                                alt
                              />
                            </div>
                            <div class="content">
                              <div class="title-row">
                                <label
                                  >{{ val.first_name | validate }}
                                  {{ val.last_name | validate }}</label
                                >
                                <span v-if="val.profile.address">{{
                                  val.profile.address | validate
                                }}</span>
                                <span
                                  class="date"
                                  v-if="val.profile.available_from"
                                  >{{
                                    val.profile.available_from
                                      | formatDate
                                      | validate
                                  }}</span
                                >
                                <span class="status" v-else>Not Available</span>
                              </div>
                              <div class="options">
                                <dropdown-menu>
                                  <ul>
                                    <li>
                                      <a
                                        href
                                        @click.prevent="
                                          manageConsultant(val.id)
                                        "
                                        >Manage Profile</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        @click.prevent="
                                          removeConsultant(item.id, val.id)
                                        "
                                        >Remove</a
                                      >
                                    </li>
                                  </ul>
                                </dropdown-menu>

                                <button
                                  class="toogle-panel-btn"
                                  @click="options.expanded = !options.expanded"
                                  v-if="!options.expanded"
                                >
                                  <img
                                    src="@/assets/admin-icon/icon-down.svg"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-slot:main="{ options }">
                          <div class="consultants-item-body">
                            <div class="consultants-info">
                              <h5>Telephone</h5>
                              <p>{{ val.profile.phone || "" | validate }}</p>
                              <h5>E-mail</h5>
                              <p>{{ val.email | validate }}</p>
                              <h5>Description</h5>
                              <p v-html="val.profile.description"></p>
                              <h5>Skills</h5>
                              <div class="skills-widget">
                                <div class="skills_content__wrapper">
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Tools</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.tools.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.tools.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any tool yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Domains</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.domains.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.domains.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any domain yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Languages</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.languages.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.languages.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{
                                          value.lang.name | validate
                                        }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any language yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="next_skills_content__wrapper">
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Competences</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.competences.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.competences.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>
                                          Have not added any competence yet.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Roles</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.roles.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.roles.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any role yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="consultants-item-body-option">
                              <button
                                class="toogle-panel-btn"
                                @click="options.expanded = !options.expanded"
                              >
                                <span
                                  class="fa fa-angle-up"
                                  v-show="options.expanded"
                                ></span>
                              </button>
                            </div>
                          </div>
                        </template>
                      </panel-expand>
                    </li>
                  </ul>

                  <div class="pitches-item-body-option">
                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                    >
                      <span
                        class="fa fa-angle-up"
                        v-show="options.expanded"
                      ></span>
                    </button>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>

        <div class="empty-widget" v-else>
          <div class="empty-widget-body">
            <p>You have not yet added any Pitch.</p>
            <button class="add-btn" @click="addUpdateForm()">
              Add New Pitch
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Pitch management -->
    <div class="pitch-management" v-show="pitch_management_modal == true">
      <div class="pitch-container">
        <div class="pitch-header">
          <h3 v-if="!pitch_form.id">Create Pitch</h3>
          <h3 v-else>Update Pitch</h3>
        </div>
        <div class="input-widget">
          <label>Pitch title</label>
          <input type="text" v-model="pitch_form.title" class="input-control" />
        </div>
        <div class="input-widget">
          <label>Pitch Description</label>
          <textarea
            type="text"
            v-model="pitch_form.description"
            class="input-control"
          ></textarea>
        </div>
        <div class="pitch-search-widget">
          <label class="pitch-title">
            <span class="text">Add Consultants</span>
            <span>
              <help-tool-tip
                position="top"
                text="A Pitch creates a copy of the consultant profiles to modify before pitching them to a customer."
              />
            </span>
          </label>
          <div class="search-container">
            <img src="@/assets/icons/search.svg" alt />
            <input
              type="text"
              placeholder="Type in to Search…"
              v-model="search_consultant_member"
            />
          </div>
          <div
            v-show="
              company_member_list &&
              company_member_list.length > 0 &&
              search_consultant_member
            "
            class="search_dropdown__body"
          >
            <div
              class="dropdown__item"
              v-for="(person, i) in company_member_list"
              :key="i"
              @click="addMate(person)"
            >
              <img
                v-if="person.profile_picture"
                :src="$fullUrl('images/profiles/' + person.profile_picture)"
                alt="picture"
              />
              <img v-else src="@/assets/avatar.png" alt />
              <div class="text">
                <span>{{
                  (person.first_name + " " + person.last_name) | validate
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pitch-body" v-if="pitch_form.members.length > 0">
          <div class="pitch-fieldset">
            <div class="collaboraters-widget">
              <div
                class="item"
                v-for="(item, i) in pitch_form.members"
                :key="i"
              >
                <img
                  v-if="item.picture"
                  :src="$fullUrl('images/profiles/' + item.picture)"
                  alt="picture"
                  class="profile-img"
                />
                <img v-else src="@/assets/avatar.png" alt class="profile-img" />
                <span class="name">{{ item.names | validate }}</span>
                <button
                  v-if="item.closable"
                  class="remove-pitch-btn"
                  @click="removeMate(item.id, i)"
                >
                  <img src="@/assets/icons/close.svg" />
                </button>
              </div>
            </div>
          </div>
          <label class="sectected-pitch-count"
            >{{ pitch_form.members.length | validate }} Consultants
            selected</label
          >
        </div>
        <div class="pitch-body" v-else>
          <label class="pitch-body-title"
            >No consultants selected to this pitch.</label
          >
        </div>
        <div class="input-widget">
          <label>Assignment name</label>
          <input
            type="text"
            v-model="pitch_form.assignment_name"
            class="input-control"
          />
        </div>
        <div class="pitch-managment-option">
          <consultfied-button
            @click="submitPitch()"
            class="btn-save"
            :loading="company_add_pitch_loading"
            >Save</consultfied-button
          >

          <button class="btn-back" @click="showPitches()">Back</button>
        </div>
      </div>
    </div>
    <!-- End Pitch management -->

    <!-- Manage consultant component -->
    <manageConsultant
      v-if="manage_consultant_component"
      :id="selected_id"
      :company_id="user.company_info.id"
      @onClose="onCloseManageConsultant()"
    ></manageConsultant>
    <!-- End of manage consultant component -->

    <!-- Select customer -->
    <selectCustomer
      :value="selected_pitch"
      v-if="show_select_customer"
      @onClose="show_select_customer = false"
    />
    <!-- End of select customer -->
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import appDialog from "@/components/Dialog/AppDialog.vue";
import ManageConsultant from "@/components/Company/ManageConsultant.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import HelpToolTip from "@/components/helper/HelpToolTip.vue";
import selectCustomer from "@/components/Company/selectCustomer.vue";

export default {
  name: "pitches",
  components: {
    panelExpand,
    appDialog,
    ManageConsultant,
    consultfiedButton,
    HelpToolTip,
    selectCustomer,
  },
  props: {},
  data: () => {
    return {
      show_select_customer: false,
      pitch_management_modal: false,
      pitches_list: true,
      tab: "all",
      manage_consultant_component: false,
      search_consultant_member: "",
      added_member_list: [],
      company_add_pitch_loading: false,
      company_member_list: [],
      pitch_form: {
        id: null,
        title: "",
        description: "",
        members: [],
        members_list: [],
        assignment_name: "",
      },
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        pitches: [],
      },
      search_pitch_input: "",
      selected_id: null,
      selected_pitch: {},
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
  },
  computed: {},
  watch: {
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
  },
  methods: {
    SendPitch(item) {
      let vm = this;
      vm.selected_pitch = item;
      vm.show_select_customer = true;
    },
    removeConsultant(pitch_id, user_id) {
      let vm = this;
      vm.$store
        .dispatch("REMOVE_MEMBER_FROM_PITCH", {
          pitch_id: pitch_id,
          user_id: user_id,
        })
        .then((responce) => {
          vm.showPitches();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchPitch() {
      let vm = this;
      let query = vm.search_pitch_input;
      if (vm.search_pitch_input) {
        vm.$store
          .dispatch("SEARCH_PITCH", { query: query })
          .then((responce) => {
            vm.user.pitches = responce.data;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        vm.getStartData();
      }
    },
    getSinglePitch(item, index) {
      let vm = this;
      vm.addUpdateForm();
      vm.pitch_form = {
        id: item.id,
        title: item.title,
        description: item.description,
        members_list: [],
        members: [],
        removedMembers: [],
        assignment_name: item.assignment_name,
      };
      item.consultants.forEach((member) => {
        let obj = {
          id: member.id,
          names: member.first_name + " " + member.last_name,
          picture: member.profile_picture,
          closable: false,
        };
        vm.pitch_form.members.push(obj);
        vm.search_consultant_member = "";
      });
    },
    getStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          vm.user.pitches.map((item) => {
            let consultants = vm.processSkills(item.consultants);
            eventBus.$set(item, "consultants", consultants);
            return item;
          });
        })
        .catch((error) => {});
    },
    processSkills(consultants) {
      return consultants.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    removePitch(item, index) {
      console.log(item);
      let vm = this;
      vm.$store
        .dispatch("REMOVE_PITCH", { id: item.id })
        .then((responce) => {
          vm.showPitches();
        })
        .catch((error) => {});
    },
    submitPitch() {
      let vm = this;
      vm.company_add_pitch_loading = true;
      vm.pitch_form.members_list = vm.pitch_form.members.map((item) => {
        return item.id;
      });
      if (!vm.pitch_form.id) {
        vm.$store
          .dispatch("ADD_PITCH", vm.pitch_form)
          .then((responce) => {
            vm.company_add_pitch_loading = false;
            vm.showPitches();
          })
          .catch((error) => {
            vm.company_add_pitch_loading = false;
          });
      } else {
        vm.$store
          .dispatch("UPDATE_PITCH", vm.pitch_form)
          .then((responce) => {
            vm.company_add_pitch_loading = false;
            vm.showPitches();
          })
          .catch((error) => {
            vm.company_add_pitch_loading = false;
          });
      }
    },
    removeMate(id, i) {
      let vm = this;
      vm.pitch_form.members.splice(i, 1);
      vm.pitch_form.removedMembers.push(id);
    },
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
        closable: true,
      };
      vm.pitch_form.members.push(obj);
      vm.search_consultant_member = "";
    },
    searchPeople(query) {
      let vm = this;
      vm.$store
        .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query })
        .then((responce) => {
          vm.company_member_list = responce.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onCloseManageConsultant() {
      let vm = this;
      vm.selected_id = null;
      vm.manage_consultant_component = false;
      vm.pitch_management_modal = false;
      vm.pitches_list = true;
      vm.showPitches();
    },
    manageConsultant(id) {
      let vm = this;
      vm.$router.push({
        name: "manage_consultant",
        params: { id: id, company_id: vm.user.company_info.id },
      });
    },
    addUpdateForm() {
      let vm = this;
      vm.pitch_management_modal = true;
      vm.pitches_list = false;
      vm.manage_consultant_component = false;
      vm.pitch_form = {
        id: null,
        title: "",
        description: "",
        members: [],
        members_list: [],
        assignment_name: "",
      };
    },
    showPitches() {
      let vm = this;
      vm.pitch_management_modal = false;
      vm.pitches_list = true;
      vm.manage_consultant_component = false;
      vm.getStartData();
    },
  },
};
</script>
<style lang="scss" scoped>
.pitches-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .company-profile-container {
    padding: 1px;
    width: 100%;
    .company-profile-body {
      border-radius: 5px;
      margin-bottom: 20px;
      background: #fff;

      .pitches-item-header {
        display: flex;
        justify-content: space-between;
        padding: 24px 22px;
        .title {
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 16px !important;
            font-weight: 800;
          }
        }
        .options {
          .add-btn {
            color: #1885ad;
            display: flex;
            font-style: italic;
            outline: none;
          }
        }
      }

      .search-add-btn-widget {
        background: #fff;
        padding: 0px 20px;
        display: grid;
        grid-template-columns: 100%;
        grid-column-gap: 20px;
        .search-widget {
          border: 1px solid #ccc;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 43px;
            width: 100%;
            padding-left: 15px;
            outline: none;
            border: none;
          }
        }
        .add-btn {
          width: 191px;
          height: 45px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-left: 10px;
          }
        }
      }
      ul.pitches-items {
        background: #ffffff;
        padding: 0px 20px;
        padding-bottom: 20px;
        list-style: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

        .pitches-starter {
          margin-bottom: 6px;
          .pitches-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              font-family: "AvenirBook";
              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .pitches-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          position: relative;
          .pitches-item-header {
            display: grid;
            padding: 10px 10px;
            grid-template-columns: 90px calc(97% - 90px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
              grid-column-gap: 10px;
              padding: 10px 12px;
            }
            .pitches-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              margin-right: 15px;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
                display: none;
              }
              img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                object-fit: cover;
                @media (min-width: 300px) and (max-width: 630px) {
                  width: 33px;
                  height: 33px;
                }
              }
            }
            .content {
              display: flex;
              width: 100%;
              padding-right: 5px;
              justify-content: space-between;
              align-items: flex-start;
              .title-row {
                font-family: "AvenirBook";
                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBlack";
                  margin-bottom: 1px;
                  font-weight: 800;
                }
                span {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  margin-bottom: 6px;
                  display: block;
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                margin-top: 0px;
                .date {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  display: flex;
                  justify-content: flex-end;
                  flex-wrap: wrap;
                  text-align: right;
                }
                .status {
                  color: #000;
                  font-family: "AvenirBook";
                  font-size: 13px;
                }
                .toogle-panel-btn {
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: absolute;
                  bottom: 10px;
                  right: 10px;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .pitches-item-body {
            padding: 10px;
            .pitches-info {
              h5 {
                text-align: left;
                color: #6e6e6e;
                font-size: 14px;
              }
              p {
                text-align: left;
                color: #000;
                font-size: 13px;
                font-weight: 800;
              }
            }
            ul.consultants-items {
              padding: 0px 0px;
              padding-bottom: 20px;
              list-style: none;
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
              .consultants-starter {
                margin-bottom: 6px;
                .consultants-item-header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 16px 0px;
                  label {
                    color: #000000;
                    font-family: "AvenirBook";
                    font-size: 16px;
                  }
                  .export-cv-btn {
                    color: #fff;
                    border: none;
                    padding: 10px 20px;
                    font-size: 14px;
                    outline: none;
                    cursor: pointer;
                    font-family: "AvenirBook";
                    background: #1ba5a4;
                    height: 40px;
                    border-radius: 5px;
                  }
                }
                p {
                  color: #131313;
                  font-family: "AvenirBook";
                }
              }
              .consultants-item {
                background: #ffffff;
                border-radius: 5px;
                margin-bottom: 10px;
                .consultants-item-header {
                  display: grid;
                  padding: 0px 4px;
                  grid-template-columns: 90px calc(98% - 90px);
                  grid-column-gap: 20px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    padding: 0px 8px;
                    grid-template-columns: 50px calc(98% - 60px);
                  }
                  .consultants-item-brand {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 90px;
                    height: 90px;
                    @media (min-width: 300px) and (max-width: 630px) {
                      width: 50px;
                    }
                    img {
                      width: 74px;
                      height: 74px;
                      border-radius: 50%;
                      object-fit: cover;
                      @media (min-width: 300px) and (max-width: 630px) {
                        width: 50px;
                        height: 50px;
                      }
                    }
                  }
                  .content {
                    display: flex;
                    width: 100%;
                    padding-right: 15px;
                    justify-content: space-between;
                    align-items: center;
                    .title-row {
                      font-family: "AvenirBook";
                      label {
                        display: block;
                        font-size: 14px;
                        font-family: "AvenirBlack";
                        margin-bottom: 1px;
                        font-weight: 800;
                      }
                      span {
                        color: #808080;
                        font-family: "AvenirBook";
                        font-size: 13px;
                        margin-bottom: 6px;
                      }
                    }
                    .options {
                      display: flex;
                      align-items: flex-end;
                      flex-direction: column;
                      .date {
                        color: #808080;
                        font-family: "AvenirBook";
                        font-size: 13px;
                      }
                      .status {
                        color: #000;
                        font-family: "AvenirBook";
                        font-size: 13px;
                      }
                      .toogle-panel-btn {
                        width: 19px;
                        padding: 0;
                        height: 22px;
                        font-size: 20px;
                        position: relative;
                        top: -3px;
                        right: -5px;
                      }
                    }
                  }
                  .toogle-panel-btn {
                    padding: 1px 40px;
                    font-size: 30px;
                    background: transparent;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    color: #ccc;
                  }
                }
                .consultants-item-body {
                  padding: 10px;
                  .consultants-info {
                    h5 {
                      text-align: left;
                      color: #6e6e6e;
                      font-size: 14px;
                    }
                    p {
                      text-align: left;
                      color: #000;
                      font-size: 13px;
                      font-weight: 800;
                    }

                    .skills-widget {
                      .skills_content__wrapper {
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr;
                        grid-column-gap: 10px;
                        margin-bottom: 10px;
                        @media (min-width: 300px) and (max-width: 630px) {
                          grid-template-columns: 1fr;
                        }
                        .skill_box {
                          min-width: 0;
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                          background: #f5f5f5;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          .skill_box_header {
                            border-bottom: 2px solid #fff;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            padding: 0px 15px;
                            label {
                              color: #0884af;
                              width: 100%;
                              font-size: 15px;
                              font-weight: 800;
                            }
                          }
                          .skill_box_body {
                            padding: 0px 15px;
                            .empty-skills {
                              display: flex;
                              flex-direction: column;
                              align-items: center;
                              height: 200px;
                              justify-content: center;
                              p {
                                text-align: center;
                                margin-bottom: 20px;
                                color: #8d8d8d;
                              }
                              button {
                                width: 133px;
                                height: 36px;
                                background: #1890a9 0% 0% no-repeat padding-box;
                                border-radius: 5px;
                                color: #fff;
                              }
                            }
                            .row__item {
                              margin-top: 10px;
                              display: flex;
                              margin-bottom: 10px;
                              justify-content: space-between;
                              width: 100%;
                              span {
                                color: #000000;
                                font-weight: normal;
                                margin-top: 2px;
                                font-size: 14px;
                                font-weight: 800;
                              }
                            }
                          }
                        }
                      }
                      .next_skills_content__wrapper {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-column-gap: 10px;
                        @media (min-width: 300px) and (max-width: 630px) {
                          grid-template-columns: 1fr;
                        }
                        .skill_box {
                          min-width: 0;
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                          background: #f5f5f5;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          .skill_box_header {
                            border-bottom: 2px solid #fff;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            padding: 0px 15px;
                            label {
                              color: #0884af;
                              width: 100%;
                              font-size: 15px;
                              font-weight: 800;
                            }
                          }
                          .skill_box_body {
                            padding: 0px 15px;
                            .empty-skills {
                              display: flex;
                              flex-direction: column;
                              align-items: center;
                              height: 200px;
                              justify-content: center;
                              p {
                                text-align: center;
                                margin-bottom: 20px;
                                color: #8d8d8d;
                              }
                              button {
                                width: 133px;
                                height: 36px;
                                background: #1890a9 0% 0% no-repeat padding-box;
                                border-radius: 5px;
                                color: #fff;
                              }
                            }
                            .row__item {
                              margin-top: 10px;
                              display: flex;
                              margin-bottom: 10px;
                              justify-content: space-between;
                              width: 100%;
                              span {
                                color: #000000;
                                font-weight: normal;
                                margin-top: 2px;
                                font-size: 14px;
                                font-weight: 800;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  .consultants-item-body-option {
                    display: flex;
                    justify-content: flex-end;
                    .toogle-panel-btn {
                      padding: 1px 9px;
                      font-size: 30px;
                      background: transparent;
                      border: none;
                      outline: none;
                      cursor: pointer;
                      color: #ccc;
                      height: 36px;
                      width: 19px;
                      padding: 0;
                      height: 22px;
                      font-size: 20px;
                      position: relative;
                      top: -3px;
                      right: -5px;
                    }
                  }
                }
              }
            }
            .pitches-item-body-option {
              display: flex;
              justify-content: flex-end;
              .toogle-panel-btn {
                padding: 1px 9px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
                height: 36px;
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: relative;
                top: -3px;
                right: -5px;
              }
            }
          }
        }
      }
      .empty-widget {
        background: #fff;
        padding: 20px;
        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          p {
            text-align: center;
            width: 270px;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .pitch-management {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 99999999999999;
    display: block;
    background: rgba(0, 0, 0, 0.5);
    overflow-y: auto;
    padding-top: 50px;
    padding-bottom: 50px;
    @media (min-width: 300px) and (max-width: 630px) {
      display: unset;
      align-items: unset;
      background: #f5f5f5;
    }
    .pitch-container {
      background: #f5f5f5;
      border-radius: 5px;
      padding: 40px 53px;
      margin: 0 auto;
      width: 500px;
      @media (min-width: 300px) and (max-width: 630px) {
        padding: 15px 23px;
        width: 100% !important;
        padding-bottom: 20px;
        display: inline-table;
      }
      .pitch-header {
        width: 100%;
        padding-bottom: 30px;
        h3 {
          text-align: left;
          margin: 0px;
          font-size: 16px;
        }
      }
      .input-widget {
        margin-bottom: 20px;
        label {
          display: block;
        }
        input {
          height: 45px;
          width: 100%;
          border: 1px solid #ccc;
          padding: 0px 10px;
          border-radius: 5px;
          outline: none;
        }
        textarea {
          height: 100px;
          width: 100%;
          border: 1px solid #ccc;
          padding: 0px 10px;
          border-radius: 5px;
          outline: none;
        }
      }
      .pitch-search-widget {
        display: flex;
        flex-direction: column;
        padding-bottom: 5px;
        position: relative;
        .pitch-title {
          display: flex;
          .text {
            margin-right: 10px;
          }
        }
        .search-container {
          border: 1px solid #ccc;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          background: #fff;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 43px;
            width: 100%;
            padding-left: 15px;
            outline: none;
          }
        }
        .search_dropdown__body {
          position: absolute;
          top: 68px;
          width: 48%;
          background: #fff;
          z-index: 999;
          box-shadow: 0px 4px 7px #ccc;
          height: 194px;
          overflow-y: auto;
          border-radius: 5px;
          .dropdown__item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e8e8e8;
            padding: 20px 10px;
            cursor: pointer;
            &:hover {
              background: #e8e8e8;
            }
            img {
              height: 30px;
              width: 30px;
              object-fit: cover;
              margin-right: 15px;
              border-radius: 50%;
            }
            .text {
              span {
                font-size: 15px;
              }
            }
          }
        }
        .invite-option {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            color: #b3b3b3;
          }
          .invite-btn {
            width: 127px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
          }
        }
      }
      .pitch-body {
        margin-bottom: 30px;
        .pitch-body-title {
          font-size: 12px;
          color: #031019;
        }
        .pitch-fieldset {
          border: 1px solid #c2c2c2;
          border-radius: 5px;
          padding: 15px;
          .collaboraters-widget {
            padding: 10px 0px;
            display: flex;
            flex-wrap: wrap;
            .item {
              background: #1ba5a4 0% 0% no-repeat padding-box;
              border-radius: 20px;
              display: flex;
              align-items: center;
              padding: 4px 4px;
              margin-right: 8px;
              margin-bottom: 8px;
              position: relative;
              .profile-img {
                width: 26px;
                height: 26px;
                border-radius: 50%;
                margin-right: 5px;
              }
              .name {
                color: #fff;
                margin-right: 10px;
              }
              .remove-pitch-btn {
                background: crimson;
                border-radius: 50%;
                height: 20px;
                width: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -11px;
                right: -7px;
              }
            }
          }
        }
        .sectected-pitch-count {
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 10px;
          display: block;
        }
      }
      .pitch-managment-option {
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;
        .btn-save {
          width: 100px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
        .btn-back {
          height: 45px;
          border-radius: 4px;
          color: #1890a9;
          outline: none;
        }
      }
    }
  }
}
</style>